import classNames from './TopCard.module.scss';
import SVG from 'react-inlinesvg';

interface TopCardProps {
  type?: 'class' | 'student';
  items: {
    icon: string;
    label: string;
    value: string;
    color?: string;
  }[];
}

const TopCard = ({ items, type = 'class' }: TopCardProps) => {
  const firstRow = items.slice(0, 3);
  const secondRow = items.slice(3, 6);
  const showTopIcon = type === 'student';
  const showLabelIcon = type === 'class';
  const containerClassName =
    type === 'student'
      ? `${classNames.topCardContainer} ${classNames.student}`
      : classNames.topCardContainer;

  return (
    <div className={containerClassName}>
      <div className={classNames.topCardRow}>
        {firstRow.map((item, index) => {
          return (
            <div key={`topCardItem--${index}`} className={classNames.topCardItem}>
              {showTopIcon && <SVG className={classNames.icon} src={item.icon} />}
              <h2 style={{ color: item.color }}>
                <span className={classNames.text}>{item.value}</span>
              </h2>
              <h5>
                {showLabelIcon ? (
                  <span className={classNames.classLabelRow}>
                    <SVG className={classNames.icon} src={item.icon} />
                    <span className={classNames.text}>{item.label}</span>
                  </span>
                ) : (
                  <span className={classNames.text}>{item.label}</span>
                )}
              </h5>
            </div>
          );
        })}
      </div>
      <div className={classNames.topCardRow}>
        {secondRow.map((item, index) => {
          return (
            <div key={`topCardItem--${index + 3}`} className={classNames.topCardItem}>
              {showTopIcon && <SVG className={classNames.icon} src={item.icon} />}
              <h2 style={{ color: item.color }}>
                <span className={classNames.text}>{item.value}</span>
              </h2>
              <h5>
                {showLabelIcon ? (
                  <span className={classNames.classLabelRow}>
                    <SVG className={classNames.icon} src={item.icon} />
                    <span className={classNames.text}>{item.label}</span>
                  </span>
                ) : (
                  <span className={classNames.text}>{item.label}</span>
                )}
              </h5>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default TopCard;
